// apps/fe/src/modules/catalog/utils/cache-utils.ts

// Central cache stores
export const filterResponseCache = new Map<string, any>();
export const categoryDataCache = new Map<string, any>();
export const userProfileDataCache = new Map<string, any>();
export const pendingRequests = new Map<string, Promise<any>>();

/**
 * Invalidates all caches or specific ones based on parameters
 * @param options Object specifying which caches to clear
 */
export function invalidateCaches({
  filters = true,
  category = true,
  userProfile = true,
  pendingReqs = false, // Be cautious with this one - only clear pending requests when necessary
  userEmail = null,
}: {
  filters?: boolean;
  category?: boolean;
  userProfile?: boolean;
  pendingReqs?: boolean;
  userEmail?: string | null;
} = {}) {
  console.log('Invalidating caches:', { filters, category, userProfile, pendingReqs, userEmail });
  /**
   * Clear cache entries that contain a specific prefix in their key
   */
  function clearCacheByPrefix(cache: Map<string, any>, prefix: string) {
    // Convert Map keys to array and iterate
    const keysToDelete = [];
    for (const key of cache.keys()) {
      if (key.includes(prefix)) {
        keysToDelete.push(key);
      }
    }

    // Delete matching keys
    keysToDelete.forEach((key) => cache.delete(key));
  }
  // If user email is provided, only clear caches for that user
  if (userEmail) {
    if (filters) clearCacheByPrefix(filterResponseCache, userEmail);
    if (category) clearCacheByPrefix(categoryDataCache, userEmail);
    if (userProfile) clearCacheByPrefix(userProfileDataCache, userEmail);
    if (pendingReqs) clearCacheByPrefix(pendingRequests, userEmail);
    return;
  }

  // Otherwise clear entire caches as requested
  if (filters) filterResponseCache.clear();
  if (category) categoryDataCache.clear();
  if (userProfile) userProfileDataCache.clear();
  if (pendingReqs) pendingRequests.clear();
}

/**
 * Invalidate cache for a specific user when they make content changes
 * @param userEmail The user's email
 */
export function invalidateUserCaches(userEmail: string) {
  if (!userEmail) return;

  invalidateCaches({ userEmail });
}

/**
 * Invalidate favorite-related caches when favorites change
 * @param userEmail The user's email
 * @param contentType Optional content type to be more specific
 */
export function invalidateFavoriteCaches(userEmail: string, contentType?: string) {
  if (!userEmail) return;

  // Clear all user caches since favorites affect multiple views
  invalidateUserCaches(userEmail);
}
